/* eslint-disable */
const getters = {
  getStatuses(state) {
    return state.data;
  },
};

export default getters;
